import React, { useCallback, useMemo, useState } from 'react';
import { get } from 'lodash';
import { createContextForController } from 'react-controller-context';
import { useCandidatesCache } from './use-candidates-cache';

const emptyArray = [];

const useController = () => {
    const { candidates, isLoading } = useCandidatesCache();
    const [ dirtyIndicator, setDirtyIndicator ] = React.useState(0);
    const [ studentFiltersMap, setStudentFiltersMap ] = useState({});
    const setDirty = () => setDirtyIndicator(v => v + 1);

    //  Adds/Removes student listing filters: (student) => boolean
    const setStudentFilter = useCallback(
        (key, filter) => setStudentFiltersMap(map => ({ ...map, [key]: filter })),
        []
    )

    const students = useMemo(() => {
        //  Pull students from candidates
        let studentCandidates = get(candidates, 'students', emptyArray);

        //  Do any student filtering
        Object.values(studentFiltersMap).forEach(filter => {
            if (filter) {
                studentCandidates = studentCandidates.filter(filter);
            }
        });
        setDirty();
        return studentCandidates;
    }, [candidates, studentFiltersMap]);

    const getStudentPreferredHour = React.useCallback((student) => {
        return student?.hourId;
    }, [dirtyIndicator]);

    const setStudentPreferredHour = (student, hourId) => {
        student.hourId = hourId;
        setDirty();
    } 

    return {
        isLoading,
        students,
        getStudentPreferredHour,
        setStudentPreferredHour,
        setStudentFilter
    };
};

const studentCollectionContext = createContextForController(useController);
export const useStudents = studentCollectionContext.useController;
export const StudentsProvider = studentCollectionContext.Provider;